export default {
  'CLICK-BTN-CUSTOMRECHECK-REPRINTLABEL': {
    key: 'click-btn-customRecheck-reprintLabel',
    label: '点击-复核打包一体化-拣货容器页-补打标签'
  },
  'CLICK-BTN-CUSTOMRECHECKGOODS-REPRINTLABEL': {
    key: 'click-btn-customRecheckGoods-reprintLabel',
    label: '点击-复核打包一体化-商品页-补打标签'
  },
  
  'SCAN-INPUT-CUSTOMRECHECK-SCANPICKINGCONTAINER': {
    key: 'scan-input-customRecheck-scanPickingContainer',
    label: '扫描-复核打包一体化-扫描拣货容器-触发扫描'
  },
  'SCAN-INPUT-CUSTOMRECHECK-SCANGOODSBARCODE': {
    key: 'scan-input-customRecheck-scanGoodsBarcode',
    label: '扫描-复核打包一体化-扫描商品条码-触发扫描'
  },
  'CLICK-BTN-CUSTOMRECHECK-FULLPACKAGE': {
    key: 'click-btn-customRecheck-fullPackage',
    label: '点击-复核打包一体化-满包裹-触发点击'
  },
  'CLICK-BTN-CUSTOMRECHECK-CONFIRMINPUTPACKAGECOUNT': {
    key: 'click-btn-customRecheck-confirmInputPackageCount',
    label: '点击-复核打包一体化-输入包裹数量确认-触发'
  },
  'SCAN-INPUT-CUSTOMRECHECK-SCANCONSUMABLESCONFIRM': {
    key: 'scan-input-customRecheck-scanConsumablesConfirm',
    label: '扫描-复核打包一体化-扫描耗材确认-触发'
  },
  'CLICK-BTN-CUSTOMRECHECK-DIFFERCONFIRM': {
    key: 'click-btn-customRecheck-differConfirm',
    label: '点击-复核打包一体化-差异确认-触发'
  },
  'CLICK-BTN-CUSTOMRECHECK-CLOSECONTAINER': {
    key: 'click-btn-customRecheck-closeContainer',
    label: '点击-复核打包一体化-关闭容器-触发'
  }
}